import styled from 'styled-components'
import {colors} from '../../../styles/theme'

export const DateBox = styled.div`
  display: flex;
  align-items: center;
`

export const StyledIcon = styled.img<{$isDivisionComplete?: boolean}>`
  width: 24px;
  height: 24px;
  margin-right: 24px;

  ${({$isDivisionComplete}) => ($isDivisionComplete ? `opacity: 0.25;` : ``)}
`

export const StyledInput = styled.input`
  width: 100%;
  height: 34px;
  border: 1px solid #6b6b6b;
  padding: 0 16px;
  box-sizing: border-box;
  font-family: Public Sans;
  color: ${colors.bksGray80};
  margin-right: 16px;
  border-radius: 2px;

  &:focus-visible {
    outline: none !important;
  }
`

export const StyledDatepickerIcon = styled.img`
  width: 16px;
  height: 16px;
  cursor: pointer;
`

export const CompletedText = styled.p`
  padding: 0;
  margin: 0;
  display: flex;
  gap: 8px;
  color: ${colors.blue1};
  margin-right: 16px;
  font-size: 14px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 34px;
`

export const DateText = styled.p`
  padding: 0;
  margin: 0;
  display: flex;
  margin-right: 16px;
  color: ${colors.bksGray80};
  font-size: 14px;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 34px;
`
